import React from 'react';
import useSessionstorage from '@rooks/use-sessionstorage';
import checkmarkIcon from '../static/icons/checkmark.svg';
import * as EasyQRCode from 'easyqrcodejs';

const formatDate = (milliseconds) => {
  const dateFromMilliseconds = new Date(Number(milliseconds));
  const formatedDate = new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short' }).format(dateFromMilliseconds);
  return formatedDate.toString();
};

export const Submitted = (props) => {
  const [submitedData] = useSessionstorage('submitedData');

  const { name, siteName, inviteCode, isEnableQrCodeWithPinInside } = submitedData || {};
  const code = React.createRef();
  const obj = {
    e: `${Date.now() + 28800000}`,
    p: `${inviteCode}`,
  };

  const trimmedSiteName = siteName && siteName.length > 26 ? siteName.substring(0, 26 - 3) + '...' : siteName;
  const expiredDateText = `Expired on ${formatDate(obj.e)}`.toUpperCase();

  React.useEffect(() => {
    props.hideLoader();
  }, [props]);

  React.useEffect(() => {
    if (submitedData && isEnableQrCodeWithPinInside) {
      new EasyQRCode(code.current, {
        text: `${JSON.stringify(obj)}`,
        width: 275,
        height: 275,
        correctLevel: EasyQRCode.CorrectLevel.H,
        quietZone: 15,
        title: trimmedSiteName?.toUpperCase(),
        titleFont: '16px Arial',
        titleHeight: 70,
        titleTop: 25,
        subTitle: expiredDateText,
        subTitleFont: '16px Arial',
        subTitleColor: 'black',
        subTitleTop: 45,
      });
    }
  }, [code, expiredDateText, isEnableQrCodeWithPinInside, obj, submitedData, trimmedSiteName]);

  if (!submitedData) {
    return null;
  }

  const downloadQRCode = () => {
    // Generate download with use canvas and stream
    const canvas = document.getElementsByTagName('canvas')[0];
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');

    let downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `${siteName}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return isEnableQrCodeWithPinInside ? (
    <>
      <div className="container w-full max-w-xs mx-auto" style={{ height: '100vh' }}>
        <div className="successSubmit flex justify-center flex-col text-white bg-blue-gradient" style={{ height: '100%' }}>
          <div className="text-lg font-extrabold text-center" style={{ color: '#f7f90c', padding: '2rem 0 1rem 0' }}>
            {name}
          </div>
          <div className="text-lg text-center successText" style={{ padding: '1rem 15px' }}>
            Questionnaire has been submitted. Please step in front of the temperature kiosk and show this QR code.
          </div>
          <div className="flex justify-center pt-4">
            <div ref={code}></div>
          </div>
          {/* <div className="text-lg text-center" style={{ textTransform: 'uppercase', padding: '1rem 0 1rem 0' }}>
            {`Expired on ${formatDate(obj.e)}`}
          </div> */}
          <div className="flex justify-center pt-6">
            <button type="button" className="buttonDownload font-extrabold" style={{ width: '290px' }} onClick={() => downloadQRCode()}>
              DOWNLOAD
            </button>
          </div>
          <div style={{ height: '100%' }}></div>
        </div>
      </div>
    </>
  ) : (
    <div>
      <div className="container w-full max-w-xs mx-auto">
        <div className="successSubmit bg-blue-gradient shadow-md px-8 pt-6 pb-8 mb-4 mt-4">
          <img className="object-scale-down h-12 w-full" src={checkmarkIcon} alt="Success" />
          <p className="text-lg font-extrabold text-center text-white successText">
            Questionnaire has been submitted. Please step in front of the temperature kiosk and enter your code.
          </p>
          {inviteCode && <p className="text-center bigLetters">{inviteCode}</p>}
        </div>
      </div>
    </div>
  );
};
